import arClient from '../../../util/api_client';
import { LEGACY_OK, OK } from '../../../constants/platformStatusCodes';

const DEBOUNCE_MS = 1500;

const pendingFeedbackIds = new Set();
let globalFlushTimer = null;

function buildUserSelectionForFeedback(detail, feedbackId) {
  if (!detail?.influencers?.length) return {};
  const fid = String(feedbackId);
  const map = {};
  detail.influencers.forEach((inf) => {
    if (inf.universalListCreatorFeedbackId == null) return;
    if (String(inf.universalListCreatorFeedbackId) !== fid) return;
    const u = inf.username;
    if (u == null || u === '') return;
    if (inf.isLike === true) {
      map[String(u)] = 1;
    } else if (inf.isDislike === true) {
      map[String(u)] = 0;
    }
  });
  return map;
}

function flushPendingUserSelections(getDetail) {
  const detail = getDetail();
  const fids = [...pendingFeedbackIds];
  pendingFeedbackIds.clear();
  fids.forEach((fid) => {
    const userSelection = buildUserSelectionForFeedback(detail, fid);
    if (Object.keys(userSelection).length === 0) {
      return;
    }
    arClient.doApiCall(
      '/universal-list/updateUserSelection',
      {
        universalListCreatorFeedbackId: fid,
        userSelection: JSON.stringify(userSelection),
      },
      (resp) => {
        if (resp.status !== OK && resp.status !== LEGACY_OK) {
          // eslint-disable-next-line no-console
          console.error('updateUserSelection failed', resp);
        }
      }
    );
  });
}

export function scheduleSyncUserSelectionForFeedback(feedbackId, getDetail) {
  if (feedbackId == null || feedbackId === '') return;
  const fid = String(feedbackId);
  pendingFeedbackIds.add(fid);
  if (globalFlushTimer != null) {
    clearTimeout(globalFlushTimer);
  }
  globalFlushTimer = setTimeout(() => {
    globalFlushTimer = null;
    flushPendingUserSelections(getDetail);
  }, DEBOUNCE_MS);
}

export function scheduleSyncUserSelectionForInfluencerIds(getDetail, creatorReportDetailIds) {
  const detail = getDetail();
  if (!detail?.influencers?.length || !creatorReportDetailIds?.length) return;
  const idSet = new Set(creatorReportDetailIds.map((id) => String(id)));
  detail.influencers.forEach((inf) => {
    if (!idSet.has(String(inf.creatorReportDetailsId))) return;
    if (inf.universalListCreatorFeedbackId != null) {
      pendingFeedbackIds.add(String(inf.universalListCreatorFeedbackId));
    }
  });
  if (globalFlushTimer != null) {
    clearTimeout(globalFlushTimer);
  }
  globalFlushTimer = setTimeout(() => {
    globalFlushTimer = null;
    flushPendingUserSelections(getDetail);
  }, DEBOUNCE_MS);
}
